// ABOUTME: Helpers for file cards: the resolveIcon name matching a file's MIME type or extension, and its extension label.
// ABOUTME: Unknown files get the generic document icon.

const IMAGE_EXTENSIONS = new Set(['PNG', 'JPG', 'JPEG', 'GIF', 'WEBP', 'SVG', 'BMP']);
const VIDEO_EXTENSIONS = new Set(['MP4', 'MOV', 'WEBM', 'AVI']);

export function fileExtension(name?: string): string {
    const clean = name?.split('?')[0] ?? '';
    const dot = clean.lastIndexOf('.');
    return dot > 0 && dot < clean.length - 1 ? clean.slice(dot + 1).toUpperCase() : '';
}

export function fileTypeIconName({ name, mimeType }: { name?: string; mimeType?: string }): string {
    const extension = fileExtension(name);
    if (mimeType === 'application/pdf' || extension === 'PDF') return 'PictureAsPdfIcon';
    if (mimeType?.startsWith('image/') || IMAGE_EXTENSIONS.has(extension)) return 'ImageIcon';
    if (mimeType?.startsWith('video/') || VIDEO_EXTENSIONS.has(extension)) return 'VideoFileIcon';
    return 'DescriptionIcon';
}
